import {Button} from "reactstrap";

type Props = {
  onClick: () => void;
  disabled: boolean;
  label: string;
};

export function MainButton({label, onClick, disabled}: Props) {
  return (
    <Button id="mainButton" type="button" color="success" onClick={onClick} disabled={disabled}>
      {label}
    </Button>
  );
}
